<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">{{ tipo === 'editar' ? 'Editar Agremiado' : tipo === 'crear' ? 'Crear Agremiado' : 'Ficha del Agremiado' }}</span></h3>
          </v-card-title>
          <v-card-text>

            <v-flex v-if="tipo === 'ver'" xs12 align-center justify-center layout text-xs-center>
              <v-avatar size="86px" tile>
                  <img v-if="form.foto" :src="form.foto" class="img-responsive" :alt="form.name">
                  <v-icon v-else color="primary">person</v-icon>
              </v-avatar>
            </v-flex>

                <!-- direccion subject -->
                <v-flex xs12 align-center justify-space-between>
                  <v-layout align-center>
                    <v-flex xs12 md4 v-if="tipo !== 'crear' && this.form.unionize">
                      <v-text-field
                        :disabled="tipo === 'ver'"
                        ref="cpc"
                        v-model="form.cpc"
                        prepend-icon="credit_card"
                        label="CPC"
                        rows="1"
                        :rules="[v => !!v || 'CPC es requerido']"
                        :error-messages="errCpc"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :disabled="tipo === 'ver'"
                        ref="name"
                        prepend-icon="person"
                        v-model="form.name"
                        :rules="[v => !!v || 'Nombre y Apellido es requerido']"
                        label="Nombre y Apellido"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>
                      <v-flex xs4>
                        <v-select
                          :items="nacionality"
                          :disabled="tipo === 'ver'"
                          v-model="form.nacionality"
                          menu-props="auto"
                          label="Nacionalidad"
                          prepend-icon="flag"
                          :rules="[v => !!v || 'Nacionalidad es requerido']"
                        ></v-select>
                      </v-flex>
                      <v-flex xs8>
                        <v-text-field
                        :disabled="tipo === 'ver'"
                        ref="number_id"
                        v-model="form.number_id"
                        prepend-icon="picture_in_picture"
                        :rules="[v => !!v || 'Cedula es requerido']"
                        :error-messages="errNumber_id"
                        label="Cedula"
                        required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs12 align-center justify-space-between>
                  <v-layout align-center>
                    <v-flex xs12 md6>
                      <v-select
                        :disabled="tipo === 'ver'"
                        :items="gender"
                        v-model="form.gender"
                        menu-props="auto"
                        label="Genero"
                        prepend-icon="wc"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-menu
                        ref="menu"
                        lazy
                        :close-on-content-click="false"
                        v-model="menu"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        min-width="290px"
                        :return-value.sync="form.birthdate"
                        :disabled="tipo === 'ver'"
                      >
                        <v-text-field
                          :disabled="tipo === 'ver'"
                          slot="activator"
                          label="Fecha de Nacimiento"
                          v-model="computedDateFormattedFecha"
                          hint="DD/MM/YYYY formato"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="form.birthdate" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.menu.save(form.birthdate)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-text-field
                  :disabled="tipo === 'ver'"
                  ref="email"
                  prepend-icon="email"
                  v-model="form.email"
                  :rules="[v => !!v || 'Email es requerido']"
                  :error-messages="errEmail"
                  label="Email"
                  required
                ></v-text-field>

                <v-autocomplete
                  :disabled="tipo === 'ver'"
                  ref="university"
                  prepend-icon="school"
                  item-text="name"
                  item-value="id"
                  :items="universities"
                  v-model="form.university_id"
                  label="Universidad"
                  :rules="[v => !!v || 'Universidad es requerido']"
                  required
                ></v-autocomplete>

                <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>
                      <v-flex xs12 md6>
                        <v-text-field
                          :disabled="tipo === 'ver'"
                          ref="home_phone"
                          mask="(####)#######"
                          prepend-icon="phone"
                          v-model="form.home_phone"
                          label="Tlf Local"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 md6>
                        <v-text-field
                          :disabled="tipo === 'ver'"
                          ref="movil"
                          mask="(####)#######"
                          prepend-icon="phone_android"
                          v-model="form.movil"
                          label="Tlf Celular"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                </v-flex>

                <v-expansion-panel v-if="tipo !== 'crear' && this.form.unionize">
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div>Datos Juramentación</div>
                    </template>
                    <v-card>
                      <v-card-text class="grey lighten-3">
                          <v-autocomplete
                            v-if="tipo !== 'crear'"
                            :disabled="tipo === 'ver'"
                            ref="college"
                            prepend-icon="school"
                            item-text="name"
                            item-value="id"
                            :items="colleges"
                            v-model="form.college_id"
                            label="Colegio"
                          ></v-autocomplete>
<!-- 
                          <v-select
                            v-if="tipo !== 'crear'"
                            :items="['LICENCIADO EN CONTADURÍA PÚBLICA', 'LICENCIADA EN CONTADURÍA PÚBLICA']"
                            :disabled="tipo === 'ver'"
                            v-model="form.title"
                            label="Titulo"
                            prepend-icon="title"
                            :rules="[v => !!v || 'Titulo es requerido']"
                          ></v-select> -->

                          <v-flex xs12 align-center justify-space-between v-if="tipo !== 'crear'">
                            <v-layout align-center>
                              <v-flex xs12 md6>
                                <v-menu
                                  :disabled="tipo === 'ver'"
                                  ref="menu3"
                                  lazy
                                  :close-on-content-click="false"
                                  v-model="menu3"
                                  transition="scale-transition"
                                  offset-y
                                  full-width
                                  :nudge-right="40"
                                  min-width="290px"
                                  :return-value.sync="form.start"
                                >
                                  <v-text-field
                                    :disabled="tipo === 'ver'"
                                    slot="activator"
                                    label="Fecha de Juramentación"
                                    v-model="computedDateFormattedFecha3"
                                    hint="DD/MM/YYYY formato"
                                    prepend-icon="event"
                                    readonly
                                  ></v-text-field>
                                  <v-date-picker v-model="form.start" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="menu3 = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.menu3.save(form.start)">OK</v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-flex>

                              <v-flex xs12 md6>
                                  <v-select
                                      :disabled="tipo === 'ver'"
                                      :items="sworn_place"
                                      ref="sworn_place"
                                      prepend-icon="add_location"
                                      v-model="form.sworn_place"
                                      label="Tipo"
                                  ></v-select>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 align-center justify-space-between v-if="tipo !== 'crear'">
                            <v-layout align-center>
                              <v-flex xs12 md6>
                                <v-menu
                                  ref="menu4"
                                  :disabled="tipo === 'ver'"
                                  lazy
                                  :close-on-content-click="false"
                                  v-model="menu4"
                                  transition="scale-transition"
                                  offset-y
                                  full-width
                                  :nudge-right="40"
                                  min-width="290px"
                                  :return-value.sync="form.fecha_resolucion"
                                >
                                  <v-text-field
                                    :disabled="tipo === 'ver'"
                                    slot="activator"
                                    label="Fecha de resolución"
                                    v-model="computedDateFormattedFecha4"
                                    hint="DD/MM/YYYY formato"
                                    prepend-icon="event"
                                    readonly
                                  ></v-text-field>
                                  <v-date-picker v-model="form.fecha_resolucion" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="menu4 = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.menu4.save(form.fecha_resolucion)">OK</v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-flex>

                              <v-flex xs12 md6>
                                  <v-text-field
                                      :disabled="tipo === 'ver'"
                                      ref="resolucion"
                                      prepend-icon="featured_play_list"
                                      v-model="form.resolucion"
                                      label="Número Resolución"
                                  ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-select
                              v-if="tipo !== 'crear'"
                              :disabled="tipo === 'ver'"
                              ref="condition"
                              :items="condition"
                              v-model="form.condition"
                              @change="changeCondition"
                              label="Estatus"
                              prepend-icon="featured_play_list"
                          ></v-select>
                          <!-- file -->
                          <input hidden type="file" ref="fileInput" @change="processFile($event)">

                          <!-- incorporado -->
                          <v-autocomplete
                              v-if="tipo !== 'crear' && form.condition == 'INCORPORADO'"
                              :disabled="tipo === 'ver'"
                              ref="old_college_id"
                              prepend-icon="school"
                              item-text="name"
                              item-value="id"
                              :items="colleges"
                              v-model="form.old_college_id"
                              label="Colegio Anterior"
                          ></v-autocomplete>

                          <v-text-field
                              v-if="tipo !== 'crear' && form.condition == 'INCORPORADO'"
                              :disabled="tipo === 'ver'"
                              ref="old_document"
                              v-model="form.old_document"
                              @click.native="onFocus"
                              prepend-icon="attach_file"
                              append-outer-icon="pageview"
                              @click:append-outer="viewOldDocument"
                              label="Documento"
                          ></v-text-field>
                          <!-- fin incorporado -->

                          <!-- traslado -->
                          <v-autocomplete
                              v-if="tipo !== 'crear' && form.condition == 'TRASLADO'"
                              :disabled="tipo === 'ver'"
                              ref="new_college_id"
                              prepend-icon="school"
                              item-text="name"
                              item-value="id"
                              :items="colleges"
                              v-model="form.new_college_id"
                              label="Nuevo Colegio"
                          ></v-autocomplete>

                          <v-text-field
                              v-if="tipo !== 'crear' && form.condition == 'TRASLADO' && tipo !== 'ver'"
                              :disabled="tipo === 'ver'"
                              ref="new_document"
                              v-model="form.new_document"
                              @click.native="onFocus"
                              prepend-icon="attach_file"
                              append-outer-icon="pageview"
                              @click:append-outer="viewNewDocument"
                              label="Documento"
                          ></v-text-field>
                          <!-- fin traslado -->


                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-flex v-if="tipo === 'ver'" xs12 align-center justify-center layout text-xs-center>
                      <img width="86px" height="40px" v-if="form.firma" :src="form.firma" class="img-responsive">
                </v-flex>
                
          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="tipo !== 'ver'" :loading="loading" class="primary" @click="submit">{{ tipo === 'editar' ? 'Actualizar' : tipo === 'crear' ? 'Crear': 'Ver' }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import { mapGetters } from 'vuex'
import VueNumeric from 'vue-numeric'

export default {
  name: 'form-user-view',

  props: {
    tipo: {
      type: String,
      required: true
    },
    datos: {
      type: Object,
      required: true
    },
    universities: {
      type: Array,
      required: true
    },
    colleges: {
      type: Array,
      required: true
    }
  },

  components: {
    VueNumeric
  },

  watch: {
    datos(v) {
      this.$refs.form.resetValidation()
      if (this.tipo == "crear") {
          this.form.university_id = '',
          this.form.email = '',
          this.form.birthdate = '',
          this.form.gender = '',
          this.form.name = '',
          this.form.number_id = '',
          this.form.start = '',
          this.form.fecha_resolucion = '',
          this.form.resolucion = '',
          this.form.condition = '',
          this.form.home_phone = '',
          this.form.movil = '',
          this.form.unionize = false,
          this.form.nacionality = ''
          this.form.college_id = '',
          this.form.old_college_id = '',
          this.form.old_document = ''
          this.form.new_college_id = '',
          this.form.new_document = '',
          this.form.file = null
      }else {
        Object.assign(this.form, v)
        this.form.home_phone = v.office_phone
        if(v.unionize != null) {
          this.form.unionize = true
          this.form.cpc = v.unionize.cpc
          //this.form.title = v.unionize.title
          this.form.start = v.unionize.start
          this.form.resolucion = v.unionize.resolucion
          this.form.condition = v.unionize.condition
          this.form.fecha_resolucion = v.unionize.fecha_resolucion
          this.form.sworn_place = v.unionize.sworn_place
          this.form.college_id = v.unionize.college_id
          if (this.form.condition == 'INCORPORADO') {
            this.form.old_college_id = v.unionize.old_college_id
            this.form.old_document = v.unionize.old_document.split("/").pop();
          }else if(this.form.condition == 'TRASLADO') {
            this.form.new_college_id = v.unionize.new_college_id
            this.form.new_document = v.unionize.new_document.split("/").pop();
          }
        }else {
          this.form.unionize = false
        }
      }
    }
  },

  computed: {

    ...mapGetters({
      authenticated: 'authCheck'
    }),

    computedDateFormattedFecha () {
      return this.formatDate(this.form.birthdate)
    },

    computedDateFormattedFecha3 () {
      return this.formatDate(this.form.start)
    },

    computedDateFormattedFecha4 () {
      return this.formatDate(this.form.fecha_resolucion)
    }

  },

  data: () => ({
    items: [],
    errCpc: [],
    errEmail: [],
    errNumber_id: [],
    gender: ['MASCULINO','FEMENINO'],
    nacionality: ['V','E','P'],
    sworn_place: ['ACTO', 'SECRETARIA'],
    condition: ['ACTIVO','NUEVO INGRESO','DIFUNTO','TRASLADO','INCORPORADO','FRAUDULENTO','DE BAJA','EXONERADO','SUSPENDIDO','INCORPORADO'],
    valid: false,
    loading: false,
    date: null,
    menu: false,
    menu3: false,
    menu4: false,
    eye: true,
    remember: false,
    busy: false,
    form: new Form({
      university_id: '',
      email: '',
      birthdate: '',
      gender: '',
      name: '',
      number_id: '',
      start: '',
      fecha_resolucion: '',
      resolucion: '',
      home_phone: '',
      movil: '',
      condition: '',
      unionize: false,
      nacionality: '',
      college_id: '',
      old_college_id: '',
      old_document: '',
      new_college_id: '',
      new_document: '',
      file: null
    }),
    formOld:{
      university_id: '',
      email: '',
      birthdate: '',
      gender: '',
      name: '',
      number_id: '',
      home_phone: '',
      movil: '',
      start: '',
      fecha_resolucion: '',
      resolucion: '',
      condition: '',
      unionize: false,
      nacionality: '',
      college_id: '',
      old_college_id: '',
      old_document: '',
      new_college_id: '',
      new_document: '',
      file: null
    }
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
  },

  methods: {

    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.submitFormAgremiado()
      }
    },

    async submitFormAgremiado () {
      try {
        let formData = new FormData();
        console.log(this.form)
        for (var key in this.form) {
          formData.append(key, this.form[key]);
        }
        if (this.tipo == 'crear') {
          const { data } = await axios.post('/api/users/admin/create_user', formData)
          console.log(data, 'data create')
          this.cerrarDialog(data)
        }else {
          formData.set('_method', 'patch')
          const { data } = await axios.post('/api/users/admin/update_agremiado', formData)
          this.cerrarDialog(data)
        }
      } catch (e) {
        console.log(e.response, 'data error create')
        this.loading = false
        if (e.response.data.errors) {
          this.form.errors.errors = e.response.data.errors
          if (e.response.data.errors.cpc) {
            this.$refs.cpc.focus()
            this.errCpc.push('Cpc ya existe')
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.cpc[0]
            })
          }else if (e.response.data.errors.email) {
            this.$refs.email.focus()
            this.errEmail.push('Email ya existe')
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.email[0]
            })
          }else if (e.response.data.errors.number_id) {
            this.$refs.number_id.focus()
            this.errNumber_id.push('Cedula ya existe')
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.number_id[0]
            })
          }
        }else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.error
          })
        }
      }

    },

    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },


    cerrarDialog (data) {
      this.$emit('closeDialogUser', data)
      this.$nextTick(() => {
        this.errCpc = []
        this.errEmail = []
        this.errNumber_id = []
        this.$refs.form.resetValidation()
        this.loading = false
     })
    },

    changeCondition () {
      if (this.form.condition == 'INCORPORADO') {
        this.form.new_college_id = ''
        this.form.new_document = ''
      }else if(this.form.condition == 'TRASLADO') {
        this.form.old_college_id = ''
        this.form.old_document = ''
      }
      this.form.file = ''
      this.$refs.fileInput.value = ''
    },

    viewNewDocument () {
      if(this.form.new_document != '') {
        window.open(window.location.protocol + "//" + window.location.host + `/storage/documento_agremiado/traslado/${this.form.new_document}`);
      }
    },

    viewOldDocument () {
      if(this.form.old_document != '') {
        window.open(window.location.protocol + "//" + window.location.host + `/storage/documento_agremiado/incorporado/${this.form.old_document}`);
      }
    },

    onFocus() {
        this.$refs.fileInput.value = ''
        this.$refs.fileInput.click()
    },

    processFile(event) {
      let files = event.target.files || event.dataTransfer.files
      if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg") {
        this.form.file = files[0]
        if (this.form.condition == 'INCORPORADO') {
          this.form.old_document = files[0].name
        }else if(this.form.condition == 'TRASLADO') {
          this.form.new_document = files[0].name
        }
      }else {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'El formato del documento debe ser PNG/JPG/JPEG'
        })
      }
    },

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/formUsers.vue